import { DATE_VALUES } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  CANCEL_SUBSCRIPTION_ASYNC,
  CREATE_PORTAL_SESSION_ASYNC,
  DEFAULT_HISTORY_PAGE_SIZE,
  DEFAULT_PEOPLE_PAGE_SIZE,
  GET_CHECKOUT_SESSION_ASYNC,
  GET_CREDITS_OVERVIEW_ASYNC,
  GET_HISTORY_LOG_ASYNC,
  GET_INVOICES_ASYNC,
  GET_PRICING_ASYNC,
  GET_SETUP_INTENT_ASYNC,
  SET_HISTORICAL_USAGE_FILTER,
  SET_HISTORY_FILTER,
  SET_INVOICES_SORT,
  SET_PEOPLE_PAGE,
  UPDATE_MONTHLY_LIMIT_ASYNC,
} from './constants'

export default function creditManagementReducer() {
  const initialState = {
    overview: { data: null, loader: false, error: null },
    historical: {
      filters: { dateFilter: DATE_VALUES.DAYS_BACK_90 },
    },
    people: {
      page: 1,
      pageSize: DEFAULT_PEOPLE_PAGE_SIZE,
    },
    history: {
      filters: {
        search: '',
        dateFilter: DATE_VALUES.MONTH,
        agents: ['soc_agent', 'red_team_agent', 'simulation_agent'],
        page: 1,
        sortBy: 'datetime',
        sortDir: 'desc',
      },
      log: {
        data: [],
        totalCount: 0,
        pageSize: DEFAULT_HISTORY_PAGE_SIZE,
        loader: false,
        error: null,
      },
    },
    billing: {
      invoices: { data: [], loader: false, error: null },
      invoiceSort: { sortBy: 'date', sortDir: 'desc' },
      pricing: { data: null, loader: false, error: null },
      setupIntent: { data: null, loader: false, error: null },
      portalSession: { data: null, loader: false, error: null },
      checkoutSession: { loader: false, error: null },
      limitUpdate: { loader: false, error: null },
      cancelSubscription: { loader: false, error: null },
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
        return initialState

      case GET_CREDITS_OVERVIEW_ASYNC.INITIATE:
        return { ...state, overview: { ...state.overview, loader: true, error: null } }
      case GET_CREDITS_OVERVIEW_ASYNC.SUCCESS:
        return { ...state, overview: { data: action.payload, loader: false, error: null } }
      case GET_CREDITS_OVERVIEW_ASYNC.ERROR:
        return { ...state, overview: { ...state.overview, loader: false, error: action.error } }
      case GET_CREDITS_OVERVIEW_ASYNC.CANCEL:
        return { ...state, overview: { ...state.overview, loader: false } }

      case SET_HISTORICAL_USAGE_FILTER:
        return {
          ...state,
          historical: {
            ...state.historical,
            filters: { ...state.historical.filters, ...action.payload },
          },
        }

      case SET_PEOPLE_PAGE:
        return { ...state, people: { ...state.people, page: action.payload.page } }

      case SET_HISTORY_FILTER:
        return {
          ...state,
          history: {
            ...state.history,
            filters: { ...state.history.filters, ...action.payload },
            log: { ...state.history.log, loader: true },
          },
        }

      case GET_HISTORY_LOG_ASYNC.INITIATE:
        return {
          ...state,
          history: { ...state.history, log: { ...state.history.log, loader: true, error: null } },
        }
      case GET_HISTORY_LOG_ASYNC.SUCCESS:
        return {
          ...state,
          history: {
            ...state.history,
            log: {
              ...state.history.log,
              loader: false,
              data: action.payload.results,
              totalCount: action.payload.totalCount,
              pageSize: action.payload.pageSize || DEFAULT_HISTORY_PAGE_SIZE,
            },
          },
        }
      case GET_HISTORY_LOG_ASYNC.ERROR:
        return {
          ...state,
          history: {
            ...state.history,
            log: { ...state.history.log, loader: false, error: action.error },
          },
        }
      case GET_HISTORY_LOG_ASYNC.CANCEL:
        return {
          ...state,
          history: { ...state.history, log: { ...state.history.log, loader: false } },
        }

      case GET_INVOICES_ASYNC.INITIATE:
        return {
          ...state,
          billing: {
            ...state.billing,
            invoices: { ...state.billing.invoices, loader: true, error: null },
          },
        }
      case GET_INVOICES_ASYNC.SUCCESS:
        return {
          ...state,
          billing: {
            ...state.billing,
            invoices: { data: action.payload, loader: false, error: null },
          },
        }
      case GET_INVOICES_ASYNC.ERROR:
        return {
          ...state,
          billing: {
            ...state.billing,
            invoices: { data: [], loader: false, error: action.error },
          },
        }
      case GET_INVOICES_ASYNC.CANCEL:
        return {
          ...state,
          billing: {
            ...state.billing,
            invoices: { ...state.billing.invoices, loader: false },
          },
        }

      case SET_INVOICES_SORT:
        return {
          ...state,
          billing: {
            ...state.billing,
            invoiceSort: {
              sortBy: action.payload.sortBy,
              sortDir: action.payload.sortDir,
            },
            invoices: { ...state.billing.invoices, loader: true, error: null },
          },
        }

      case GET_PRICING_ASYNC.INITIATE:
        return {
          ...state,
          billing: {
            ...state.billing,
            pricing: { ...state.billing.pricing, loader: true, error: null },
          },
        }
      case GET_PRICING_ASYNC.SUCCESS:
        return {
          ...state,
          billing: {
            ...state.billing,
            pricing: { data: action.payload, loader: false, error: null },
          },
        }
      case GET_PRICING_ASYNC.ERROR:
        return {
          ...state,
          billing: {
            ...state.billing,
            pricing: { data: null, loader: false, error: action.error },
          },
        }
      case GET_PRICING_ASYNC.CANCEL:
        return {
          ...state,
          billing: {
            ...state.billing,
            pricing: { ...state.billing.pricing, loader: false },
          },
        }

      case GET_SETUP_INTENT_ASYNC.INITIATE:
        return {
          ...state,
          billing: {
            ...state.billing,
            setupIntent: { ...state.billing.setupIntent, loader: true, error: null },
          },
        }
      case GET_SETUP_INTENT_ASYNC.SUCCESS:
        return {
          ...state,
          billing: {
            ...state.billing,
            setupIntent: { data: action.payload, loader: false, error: null },
          },
        }
      case GET_SETUP_INTENT_ASYNC.ERROR:
        return {
          ...state,
          billing: {
            ...state.billing,
            setupIntent: { data: null, loader: false, error: action.error },
          },
        }
      case GET_SETUP_INTENT_ASYNC.CANCEL:
        return {
          ...state,
          billing: {
            ...state.billing,
            setupIntent: { ...state.billing.setupIntent, loader: false, error: null },
          },
        }

      case CREATE_PORTAL_SESSION_ASYNC.INITIATE:
        return {
          ...state,
          billing: {
            ...state.billing,
            portalSession: { data: null, loader: true, error: null },
          },
        }
      case CREATE_PORTAL_SESSION_ASYNC.SUCCESS:
        return {
          ...state,
          billing: {
            ...state.billing,
            portalSession: { data: action.payload, loader: false, error: null },
          },
        }
      case CREATE_PORTAL_SESSION_ASYNC.ERROR:
        return {
          ...state,
          billing: {
            ...state.billing,
            portalSession: { data: null, loader: false, error: action.error },
          },
        }
      case CREATE_PORTAL_SESSION_ASYNC.CANCEL:
        return {
          ...state,
          billing: {
            ...state.billing,
            portalSession: { ...state.billing.portalSession, loader: false, error: null },
          },
        }

      case GET_CHECKOUT_SESSION_ASYNC.INITIATE:
        return {
          ...state,
          billing: {
            ...state.billing,
            checkoutSession: { loader: true, error: null },
          },
        }
      case GET_CHECKOUT_SESSION_ASYNC.SUCCESS:
        return {
          ...state,
          billing: {
            ...state.billing,
            checkoutSession: { loader: false, error: null },
          },
        }
      case GET_CHECKOUT_SESSION_ASYNC.ERROR:
        return {
          ...state,
          billing: {
            ...state.billing,
            checkoutSession: { loader: false, error: action.error },
          },
        }
      case GET_CHECKOUT_SESSION_ASYNC.CANCEL:
        return {
          ...state,
          billing: {
            ...state.billing,
            checkoutSession: { ...state.billing.checkoutSession, loader: false, error: null },
          },
        }

      // The optimistic billing/status patch + rollback now lives in the Agents
      // slice (single source of truth). Here we only track the request loader/error.
      case UPDATE_MONTHLY_LIMIT_ASYNC.INITIATE:
        return {
          ...state,
          billing: {
            ...state.billing,
            limitUpdate: { loader: true, error: null },
          },
        }
      case UPDATE_MONTHLY_LIMIT_ASYNC.SUCCESS:
        return {
          ...state,
          billing: {
            ...state.billing,
            limitUpdate: { loader: false, error: null },
          },
        }
      case UPDATE_MONTHLY_LIMIT_ASYNC.ERROR:
        return {
          ...state,
          billing: {
            ...state.billing,
            limitUpdate: { loader: false, error: action.error },
          },
        }
      case UPDATE_MONTHLY_LIMIT_ASYNC.CANCEL:
        return {
          ...state,
          billing: {
            ...state.billing,
            limitUpdate: { ...state.billing.limitUpdate, loader: false },
          },
        }

      case CANCEL_SUBSCRIPTION_ASYNC.INITIATE:
        return {
          ...state,
          billing: {
            ...state.billing,
            cancelSubscription: { loader: true, error: null },
          },
        }
      case CANCEL_SUBSCRIPTION_ASYNC.SUCCESS:
        return {
          ...state,
          billing: {
            ...state.billing,
            cancelSubscription: { loader: false, error: null },
          },
        }
      case CANCEL_SUBSCRIPTION_ASYNC.ERROR:
        return {
          ...state,
          billing: {
            ...state.billing,
            cancelSubscription: { loader: false, error: action.error },
          },
        }
      case CANCEL_SUBSCRIPTION_ASYNC.CANCEL:
        return {
          ...state,
          billing: {
            ...state.billing,
            cancelSubscription: { ...state.billing.cancelSubscription, loader: false },
          },
        }

      default:
        return state
    }
  }
}
